import React, { useEffect, useState, useRef } from "react";
import moment from "jalali-moment";

// import JS files
import RingNumbersEdit from "../../../shares/RingNumbersEdit";
import { useProducerBasket } from "../../../../context/ProducerBasketContext";
import MuiDatePicker from "../../../shares/MuiDatePicker";
import { fixNumbers } from "../../../../utils";
import MuiButtonRef from "../../../shares/MuiButtonRef";
import { useSetting } from "../../../../context/SettingContext";

const POrderCardLeftPart = (props) => {
  const { defaultRingSize, reverseShowNums } = useSetting();
  const [dateValue, setDateValue] = useState(moment());

  function dateOnChange(date) {
    setDateValue(date);
  }

  const create_default_value = (ri) => {
    let defaults = [
      ri.admin_size_one_num !== 0 ? ri.admin_size_one_num : "",
      ri.admin_size_two_num !== 0 ? ri.admin_size_two_num : "",
      ri.admin_size_three_num !== 0 ? ri.admin_size_three_num : "",
      ri.admin_size_four_num !== 0 ? ri.admin_size_four_num : "",
      ri.admin_size_five_num !== 0 ? ri.admin_size_five_num : "",
      ri.admin_size_six_num !== 0 ? ri.admin_size_six_num : "",
    ];
    if (
      ri.size_one_weight == "" ||
      ri.size_one_weight == "0.0" ||
      ri.size_one_weight == "0"
    )
      defaults[0] = "";
    if (
      ri.size_two_weight == "" ||
      ri.size_two_weight == "0.0" ||
      ri.size_two_weight == "0"
    )
      defaults[1] = "";
    if (
      ri.size_three_weight == "" ||
      ri.size_three_weight == "0.0" ||
      ri.size_three_weight == "0"
    )
      defaults[2] = "";
    if (
      ri.size_four_weight == "" ||
      ri.size_four_weight == "0.0" ||
      ri.size_four_weight == "0"
    )
      defaults[3] = "";
    if (
      ri.size_five_weight == "" ||
      ri.size_five_weight == "0.0" ||
      ri.size_five_weight == "0"
    )
      defaults[4] = "";
    if (
      ri.size_six_weight == "" ||
      ri.size_six_weight == "0.0" ||
      ri.size_six_weight == "0"
    )
      defaults[5] = "";

    return defaults;
  };
  const [nums, setNums] = useState(
    props.needDefaultValue !== undefined
      ? create_default_value(props.item)
      : new Array(defaultRingSize + 1).fill("")
  );
  const { AddRing } = useProducerBasket();
  const update_nums = (ind, nValue) => {
    // if (reverseShowNums) {
    //   ind = defaultRingSize - ind;
    // }
    let beforeNums = [...nums];
    beforeNums[ind] = fixNumbers(nValue);
    setNums(beforeNums);
  };

  const add_new_ring = () => {
    try {
      AddRing(
        props.item,
        nums,
        dateValue,
        props.selectedUser !== undefined ? props.selectedUser : null,
        true
      );

      if (props.emptySearchData !== undefined) {
        props.empty_search();
      }
      if (props.hasOpenModal != undefined) props.setOpenModal(false);
    } catch (error) {}

    props.setOpenModal(false);
    // if(props.producerCreateOrder)props.update_admin_producer_ring_nums(nums,props.item)
  };

  const htmlElRef = useRef(null);
  const useFocus = () => {
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
  };
  const [inputRef, setInputFocus] = useFocus();
  let random_num = Math.random() * 10;

  const [checkDisable, setCheckDisable] = useState(true);
  useEffect(() => {
    for (let index = 0; index < nums.length; index++) {
      if (nums[index] !== "0" && nums[index] !== "") {
        setCheckDisable(false);
        return;
      } else {
        setCheckDisable(true);
      }
    }
  }, [nums]);

  return (
    <>
      <div className="md:grid grid-cols-12 gap-x-2 items-center">
        <div className="md:col-span-9">
          <RingNumbersEdit
            item={props.item}
            dynamicMap
            nums={nums}
            update_nums={update_nums}
            random_num={random_num}
          />
        </div>
        <div className="md:col-span-3 grid grid-cols-2 md:grid-cols-3 mt-4">
          <div className="md:col-span-2 mr-2 md:mr-0" tabIndex="-1">
            <MuiDatePicker onChange={dateOnChange} value={dateValue} />
          </div>
          <div
            className="md:col-span-1 text-left mt-1 amin"
            tabIndex={defaultRingSize + 2 + random_num}
            onFocus={setInputFocus}
          >
            <MuiButtonRef
              ref={inputRef}
              onClick={add_new_ring}
              variant="contained"
              color="success"
              text="افزودن"
              size="small"
              disabled={checkDisable}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default POrderCardLeftPart;
